import { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { Eye, X } from 'lucide-react';
import api from '@/lib/api';

export function ImpersonationBanner() {
  const [tenantName, setTenantName] = useState(null);

  useEffect(() => {
    const name = localStorage.getItem('impersonate_tenant_name');
    if (name) setTenantName(name);
  }, []);

  const exitImpersonation = async () => {
    try {
      const res = await api.post('/admin/impersonate/exit');
      const originalToken = localStorage.getItem('original_token');
      const originalUser = localStorage.getItem('original_user');
      localStorage.setItem('token', originalToken || res.data.access_token);
      if (originalUser) localStorage.setItem('user', originalUser);
      localStorage.removeItem('original_token');
      localStorage.removeItem('original_user');
      localStorage.removeItem('impersonate_tenant_name');
      localStorage.removeItem('impersonate_tenant_id');
      window.location.href = '/super-admin';
    } catch {
      // Fallback: restore from original token
      const originalToken = localStorage.getItem('original_token');
      if (originalToken) {
        localStorage.setItem('token', originalToken);
        localStorage.removeItem('original_token');
        localStorage.removeItem('original_user');
        localStorage.removeItem('impersonate_tenant_name');
        localStorage.removeItem('impersonate_tenant_id');
        window.location.href = '/super-admin';
      }
    }
  };

  if (!tenantName) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-[9999] bg-warning text-white px-4 py-2 flex items-center justify-center gap-3 shadow-lg" data-testid="impersonation-banner">
      <Eye size={16} />
      <span className="text-sm font-medium">
        Support Mode — Viewing as <strong>{tenantName}</strong>
      </span>
      <Button
        size="sm"
        variant="secondary"
        onClick={exitImpersonation}
        className="h-7 bg-white/20 hover:bg-white/30 text-white border-0 text-xs"
        data-testid="exit-impersonation-btn"
      >
        <X size={12} className="mr-1" />
        Exit
      </Button>
    </div>
  );
}
